import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { ChargeDetailStatus } from './chargeSlab.types';

export interface ManagePayload {
  chargeCategoryDetailId: string;
  categoryId: string;
  fromAmount: number;
  toAmount: number;
  chargeType: string;
  chargeValue: number;
  minChargeValue: number;
  maxChargeValue: number;
}

export interface ToggleChargeDetailStatusPayload {
  chargeCategoryDetailId: string;
  status: 'A' | 'S' | 'D';
}

const manageChargeCategory = (client: AxiosInstance) => async (payload: ManagePayload) => {
  return (
    await client.post<{ message: string; data: ManagePayload }>(API_ROUTES.MANAGE_CHARGE_DETAIL, {
      ...payload,
    })
  ).data;
};

const toggleChargeDetailStatus = (client: AxiosInstance) => async (payload: ToggleChargeDetailStatusPayload) => {
  return (await client.post<{ message: string; data: ChargeDetailStatus }>(API_ROUTES.CHARGE_DETAIL_STATUS, payload))
    .data;
};

export const chargeSlabMutations = {
  manageChargeCategory,
  toggleChargeDetailStatus,
};
